module.exports = __webpack_public_path__ + "img/Group 87@2x.d5b23379.png";